import { render, staticRenderFns } from "./svg-preloader.vue?vue&type=template&id=2e42691e&scoped=true&"
var script = {}
import style0 from "./svg-preloader.vue?vue&type=style&index=0&id=2e42691e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42691e",
  null
  
)

export default component.exports